import React, { useState, useEffect } from "react";
import axios from "axios";
import "../assets/Cibil/Cibil.css";
import { Info, CheckCircle, CreditCard, AlertTriangle, Pencil } from "lucide-react";
import { toast } from "react-toastify";

export default function CibilCheck() {
  // --------------------
  // FORM STATE
  // --------------------
  const [form, setForm] = useState({
    fullName: "",
    dob: "",
    pan: "",
    aadhaar: "",
    mobile: "",
    email: "",
    proof: "",
    proofNumber: "",
    relation: "",
    relationName: "",
    address: "",
    pin: "",
    consent: false,
  });

  // --------------------
  // API USER STATE
  // --------------------
  const [cibilUser, setCibilUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(false);
  const [wallet, setWallet] = useState(0);
const [price, setPrice] = useState(0);
const [uid, setUid] = useState("");


  // --------------------
  // ERROR + SUBMIT STATE
  // --------------------
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  // --------------------
  // HANDLE INPUT CHANGE
  // --------------------
  const handleChange = (field) => (e) => {
    const value =
      field === "pan"
        ? e.target.value.toUpperCase()
        : field === "consent"
        ? e.target.checked
        : e.target.value;

    setForm({ ...form, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  // --------------------
  // FORM VALIDATION
  // --------------------
  const validate = () => {
    let err = {};

    if (!form.fullName.trim()) err.fullName = "Full name required";
    if (!form.dob) err.dob = "Date of birth required";
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(form.pan)) err.pan = "Invalid PAN format";
    if (!/^[6-9]\d{9}$/.test(form.mobile)) err.mobile = "Invalid Mobile number";
    if (form.aadhaar && !/^\d{12}$/.test(form.aadhaar)) err.aadhaar = "Aadhaar must be 12 digits";
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) err.email = "Invalid email";

    if (form.proof && !form.proofNumber) err.proofNumber = "Document number required";
    if (form.relation && !form.relationName) err.relationName = "Name is required";

    if (!form.consent) err.consent = "Consent required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // --------------------
  // FETCH CIBIL PROFILE API
  // --------------------
  useEffect(() => {
    getCibilUser();
  }, []);
const getCibilUser = async () => {
  try {
    setLoadingUser(true);

    const email = "sonu@gmail.com";

    const res = await axios.get(
      `https://payyug.in/api/cibil-profile-user-by-email?email=${email}`
    );

    if (res.data.success) {
      const data = res.data.data;

      setCibilUser(data);
      setWallet(data.wallet);
      setPrice(data.price);
      setUid(data.uid);
    }
  } catch (err) {
    console.log("CIBIL USER ERROR", err);
  } finally {
    setLoadingUser(false);
  }
};

  // --------------------
  // SUBMIT FORM
  // --------------------
  const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitted(false);

  if (!cibilUser) {
    return toast.warn("CIBIL User profile not loaded yet.");
  }

  if (!validate()) return;

// if (wallet < price) {
//     return alert("Insufficient wallet balance!");
// }


  try {
    // -----------------------------
    // STEP 1: Prepare CIBIL request
    // -----------------------------
    const body1 = {
      firstName: form.fullName.trim(),
      lastName: "",
      dob: form.dob.trim(),
      addressLine1: form.address.trim(),
      state: "Delhi",
      city: "New Delhi",
      postal: form.pin.trim(),
      phoneNumber: form.mobile.trim(),
      aadhaarNumber: form.aadhaar.trim(),
      panCard: form.pan.trim(),
      voterId: form.proofNumber.trim(),
      relation: form.relationName.trim(),
    };

    const cibilResponse = await axios.post(
      "https://payyug.in/api/cibilalfasalma",
      body1,
      { headers: { "Content-Type": "application/json" } }
    );

    const json = cibilResponse.data;

    if (json.data && json.data.Error) {
      return toast.error(`CIBIL API Error: ${json.data.Error.ErrorDesc}`);
    }

    const encodedPdf = json.data?.EncodedPdf;

    if (!encodedPdf) {
      return toast.error("No PDF found in the CIBIL response.");
    }

    const inquiry = json.data.InquiryRequestInfo;

    // -----------------------------
    // STEP 2: Save Report in your DB
    // -----------------------------
    const body2 = {
      uid: uid,
      fullName: inquiry?.FirstName ?? "",
      dob: inquiry?.DOB ?? "",
      addressLine1: form.address.trim(),
      state: "Delhi",
      city: "New Delhi",
      postal: form.pin.trim(),
      phoneNumber: form.mobile.trim(),
      aadhaarNumber: form.aadhaar.trim(),
      panCard: form.pan.trim(),
      voterId: form.proofNumber.trim(),
      relation: form.relationName.trim(),
      EncodedPdf: encodedPdf,
    };

    const saveRes = await axios.post(
      "https://payyug.in/api/create-cibiil",
      body2,
      { headers: { "Content-Type": "application/json" } }
    );

    if (saveRes.status === 201) {
      console.log("Saved successfully:", saveRes.data);
    } else {
      toast.error("Failed to save CIBIL report!");
    }

    // -----------------------------
    // STEP 3: Deduct Wallet Amount
    // -----------------------------
    const newWallet = wallet - price;

    const walletUpdate = await axios.put(
      `https://payyug.in/api/cibil-wallet/${uid}`,
      { wallet: newWallet },
      { headers: { "Content-Type": "application/json" } }
    );

    if (walletUpdate.status !== 200) {
      toast.error("Wallet update failed!");
    }

    setSubmitted(true);
    toast.success("CIBIL Report Fetch Successful!");

  } catch (err) {
    console.error("Submit error:", err);
    toast.error("Something went wrong.");
  }
};

  // --------------------
  // CLEAR FORM
  // --------------------
  const handleClear = () => {
    setForm({
      fullName: "",
      dob: "",
      pan: "",
      aadhaar: "",
      mobile: "",
      email: "",
      proof: "",
      proofNumber: "",
      relation: "",
      relationName: "",
      address: "",
      pin: "",
      consent: false,
    });
    setErrors({});
    setSubmitted(false);
  };

  // --------------------
  // UI PART
  // --------------------
  return (
    <div>
      <div className="cibil-wrap">
        <h3>CIBIL CHECK</h3>

        <form className="cibil-form" onSubmit={handleSubmit} noValidate>
          
          {/* Name + Email */}
          <div className="row two">
            <div>
              <label className="cibillabel">Full Name * :</label>
              <input
                value={form.fullName}
                onChange={handleChange("fullName")}
                className="cibilinput"
              />
              {errors.fullName && <p className="err">{errors.fullName}</p>}
            </div>

            <div>
              <label className="cibillabel">Email :</label>
              <input
                value={form.email}
                onChange={handleChange("email")}
                className="cibilinput"
              />
              {errors.email && <p className="err">{errors.email}</p>}
            </div>
          </div>

          {/* DOB + PAN */}
          <div className="row two">
            <div>
              <label className="cibillabel">Date of Birth * :</label>
              <input
                type="date"
                value={form.dob}
                onChange={handleChange("dob")}
                className="cibilinput"
              />
              {errors.dob && <p className="err">{errors.dob}</p>}
            </div>

            <div>
              <label className="cibillabel">PAN * :</label>
              <input
                maxLength={10}
                value={form.pan}
                onChange={handleChange("pan")}
                placeholder="Ex - ABCDE1234F"
                className="cibilinput"
              />
              {errors.pan && <p className="err">{errors.pan}</p>}
            </div>
          </div>

          {/* Aadhaar + Mobile */}
          <div className="row two">
            <div>
              <label className="cibillabel">Aadhaar:</label>
              <input
                maxLength={12}
                value={form.aadhaar}
                onChange={handleChange("aadhaar")}
                className="cibilinput"
              />
              {errors.aadhaar && <p className="err">{errors.aadhaar}</p>}
            </div>

            <div>
              <label className="cibillabel">Inquiry Phone * :</label>
              <input
                maxLength={10}
                value={form.mobile}
                onChange={handleChange("mobile")}
                className="cibilinput"
              />
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>
          </div>

          {/* Address Proof */}
          <div className="row two">
            <div>
              <label className="cibillabel">Address Proof :</label>
              <select
                value={form.proof}
                onChange={handleChange("proof")}
                className="cibilinput"
              >
                <option value="">Select Document</option>
                <option value="passport">Passport</option>
                <option value="voter">Voter ID</option>
                <option value="dl">Driving License</option>
                <option value="bill">Utility Bill</option>
              </select>
            </div>

            <div>
              <label className="cibillabel">Enter ID Number * :</label>
              <input
                value={form.proofNumber}
                onChange={handleChange("proofNumber")}
                className="cibilinput"
              />
              {errors.proofNumber && <p className="err">{errors.proofNumber}</p>}
            </div>
          </div>

          {/* Relation + Name */}
          <div className="row two">
            <div>
              <label className="cibillabel">Relation :</label>
              <select
                value={form.relation}
                onChange={handleChange("relation")}
                className="cibilinput"
              >
                <option value="">Select Relation</option>
                <option value="father">Father</option>
                <option value="mother">Mother</option>
                <option value="wife">Wife</option>
                <option value="husband">Husband</option>
                <option value="brother">Brother</option>
                <option value="sister">Sister</option>
                <option value="son">Son</option>
                <option value="daughter">Daughter</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div>
              <label className="cibillabel">Enter Full Name * :</label>
              <input
                value={form.relationName}
                onChange={handleChange("relationName")}
                className="cibilinput"
              />
              {errors.relationName && <p className="err">{errors.relationName}</p>}
            </div>
          </div>

          {/* Address + Pin */}
          <div className="row two">
            <div>
              <label className="cibillabel">Address :</label>
              <input
                value={form.address}
                onChange={handleChange("address")}
                className="cibilinput"
              />
            </div>

            <div>
              <label className="cibillabel">Pin Code :</label>
              <input
                maxLength={6}
                value={form.pin}
                onChange={handleChange("pin")}
                className="cibilinput"
              />
            </div>
          </div>

          {/* Consent */}
          <div className="rowconsent">
            <label>
              <input
                type="checkbox"
                checked={form.consent}
                onChange={handleChange("consent")}
              />
              &nbsp;I confirm I have customer’s written consent. *
            </label>
            {errors.consent && <p className="err">{errors.consent}</p>}
          </div>

          {/* Buttons */}
<div className="cibilbtn">
  <button type="submit" className="cibilbtn-submit">
    Submit
  </button>
  <button type="button" className="cibilbtn-clear" onClick={handleClear}>
    Clear
  </button>
</div>



          {submitted && <p className="cibilbtn-success">Submitted successfully!</p>}
        </form>
      </div>

      {/* INFO BOX */}
      <div className="credit-box">
        <div className="title-row">
          <Info size={22} className="info-icon" />
          <h3>
            Important: Follow the instructions below to fetch your credit score accurately:
          </h3>
        </div>

        <ul className="info-list">
          <li>
            <CheckCircle className="icon success" size={20} />
            <span>
              <b>Provide accurate personal details</b> such as your <i>full name, phone number,</i> and <i>date of birth</i>.
            </span>
          </li>

          <li>
            <CreditCard className="icon card" size={20} />
            <span>
              <b>Use Aadhaar or PAN</b> as your <i>primary ID</i> for best results.
            </span>
          </li>

          <li>
            <AlertTriangle className="icon warning" size={20} />
            <span>
              <b>Incorrect information</b> may cause the report to fail.
            </span>
          </li>

          <li>
            <Pencil className="icon pencil" size={20} />
            <span>Please fill all required fields carefully.</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
